// src/utils/games.js
// ⚠️ Do not break the existing structure. We only extend additively with optional fields.
// Important: There must be exactly ONE "export const gamesList". NO default export.

export const gamesList = [
  {
    key: 'ea-fc',
    name: 'EA FC',
    releaseDate: '2025-09-26', // optional (ISO), für Sort "Release date"
    icon: 'ea-fc.webp',
    shortDescription: 'The world’s biggest football game. Squad up and compete.',
    longDescription:
      'EA SPORTS FC 26 delivers authentic football with 20,000+ licensed players, 700+ clubs and 30+ leagues. Compete in Ultimate Team, Clubs and Volta with revamped gameplay systems, smarter AI and improved physics. Build your dream squad and take on weekly competitions and live events.',
    sections: [
      { title: 'Ultimate Team', body: 'Build and evolve your dream squad with seasonal ladders and revamped chemistry.' },
      { title: 'Clubs', body: 'Climb divisions with your friends in social 11v11 modes and weekly challenges.' },
      { title: 'Gameplay', bullets: ['Enhanced physics', 'Smarter AI positioning', 'Timed finishing refinements'] }
    ],
    heroUrl: 'https://image.api.playstation.com/vulcan/ap/rnd/202507/1617/27132291f4187708f316b43f65ab887a74fdf325f4ece306.png',
    heroSrcset: [
      'https://image.api.playstation.com/vulcan/ap/rnd/202507/1617/27132291f4187708f316b43f65ab887a74fdf325f4ece306.png?w=1280 1280w',
      'https://image.api.playstation.com/vulcan/ap/rnd/202507/1617/27132291f4187708f316b43f65ab887a74fdf325f4ece306.png?w=1920 1920w',
      'https://image.api.playstation.com/vulcan/ap/rnd/202507/1617/27132291f4187708f316b43f65ab887a74fdf325f4ece306.png?w=2560 2560w'
    ].join(', '),
    publisher: 'EA',
    developer: 'EA Vancouver & EA Romania',
    platforms: ['PS5', 'PS4', 'Xbox Series X|S', 'Xbox One', 'PC', 'Switch', 'Luna'],
    genres: ['Sports'],
    rating: { system: 'PEGI', value: '3' },
    competitive: true,
    featured: true,
    heroKey: 'hero-background.webp',
    trailers: ['F2Q4xrASt94', 'TSi0iJYSQ24'],
    trailerYouTubeId: 'F2Q4xrASt94',
    storeLinks: {
      psn: 'https://www.playstation.com/games/ea-sports-fc/',
      xbox: 'https://www.xbox.com/games/store/ea-sports-fc',
      steam: 'https://store.steampowered.com/app/3405690/EA_SPORTS_FC_26/',
      epic: 'https://store.epicgames.com/en-US/p/ea-sports-fc-26',
      eaapp: 'https://www.ea.com/en/games/ea-sports-fc/fc-26/buy',
      luna: 'https://luna.amazon.com/game/ea-sports-fc-26/B0CW18YWZF',
      switch: 'https://www.nintendo.com/us/store/products/ea-sports-fc-26-switch/',
      official: 'https://www.ea.com/en/games/ea-sports-fc/fc-26'
    }
  },

  {
    key: 'clash-royale',
    name: 'Clash Royale',
    releaseDate: '2016-03-02',
    icon: 'clash-royale.webp',
    shortDescription: 'Fast-paced real-time strategy battles on mobile.',
    longDescription:
      'Clash Royale is a real-time strategy game with card decks from the Clash universe. Collect and upgrade cards, build your deck and conquer arenas in quick PvP matches. Join clans, trade cards and compete in seasonal events with new balancing updates and challenges.',
    sections: [
      { title: 'Arenas & Leagues', body: 'Climb through arenas and unlock seasonal rewards.' },
      { title: 'Clans', body: 'Join or create clans, donate cards and fight in clan wars.' },
      { title: 'Gameplay', bullets: ['3-minute PvP matches', 'Card evolutions & balance updates', 'Seasonal challenges'] }
    ],
    // Deine neue URL (Supercell)
    heroUrl: 'https://supercell.com/images/c96611b5b4ccd331e2b4dcb797811894/1050/hero_bg_clashroyale.612fcf42.webp',
    // kein heroSrcset gesetzt, da der Host hier fixe Pfadbreiten nutzt (1050) – später gern erweiterbar
    trailers: ['HAB6OPF9EhQ', 'y9yCNrBhtgk'],
    trailerYouTubeId: 'HAB6OPF9EhQ',
    publisher: 'Supercell',
    developer: 'Supercell',
    platforms: ['iOS', 'Android'],
    genres: ['Strategy'],
    rating: { system: 'PEGI', value: '7' },
    competitive: true,
    featured: false,
    heroKey: 'hero-background.webp',
    storeLinks: {
      appstore: 'https://apps.apple.com/app/clash-royale/id1053012308',
      playstore: 'https://play.google.com/store/apps/details?id=com.supercell.clashroyale',
      official: 'https://supercell.com/en/games/clashroyale/'
    }
  },

  {
    key: 'cod',
    name: 'COD',
    releaseDate: '2024-10-25',
    icon: 'cod.webp',
    shortDescription: 'The latest Call of Duty. Multiplayer and Warzone action.',
    longDescription:
      'Call of Duty: Black Ops 6 brings a 90s spy-thriller campaign, best-in-class multiplayer and the return of round-based Zombies. Warzone is integrated as a free-to-play battle royale with shared progression systems and seasonal updates.',
    sections: [
      { title: 'Multiplayer', body: 'Fast-paced 6v6 with new and remastered maps.' },
      { title: 'Zombies', body: 'Round-based co-op action with wonder weapons, perks and hidden Easter eggs.' },
      { title: 'Gameplay', bullets: ['Shared progression with Warzone', 'Seasonal content drops', 'Ranked play support'] }
    ],
    // Deine neue URL (offizielle Call of Duty Hero-Desktop-WebP)
    heroUrl: 'https://www.callofduty.com/content/dam/atvi/callofduty/cod-touchui/blackops6/pc/Bo6_PC_Hero_Desktop.webp',
    // kein heroSrcset: Host bietet hier keine stabilen Größenparameter
    trailers: ['LrBzuHF0sHs'],
    trailerYouTubeId: 'LrBzuHF0sHs',
    publisher: 'Activision',
    developer: 'Treyarch & Raven Software',
    platforms: ['PS5', 'PS4', 'Xbox Series X|S', 'Xbox One', 'PC'],
    genres: ['FPS'],
    rating: { system: 'PEGI', value: '18' },
    competitive: true,
    featured: true,
    heroKey: 'hero-background.webp',
    storeLinks: {
      psn: 'https://www.playstation.com/en-us/games/call-of-duty-black-ops-6/',
      xbox: 'https://www.xbox.com/games/call-of-duty-black-ops-6',
      steam: 'https://store.steampowered.com/app/2933620/Call_of_Duty_Black_Ops_6/',
      battleNet: 'https://us.shop.battle.net/product/call-of-duty-black-ops-6',
      official: 'https://www.callofduty.com/blackops6/pc'
    }
  },

  {
    key: 'cs-go',
    name: 'CS:GO',
    releaseDate: '2023-09-27',
    icon: 'cs-go.webp',
    shortDescription: 'Counter-Strike esports classic – our wiring name “CS:GO”.',
    longDescription:
      'Counter-Strike 2 is the free Source 2 upgrade with responsive smokes, sub-tick networking, new ranking (CS Rating) and refreshed maps. The core remains skill-based 5v5 rounds of bomb defusal or hostage rescue.',
    sections: [
      { title: 'Premier & CS Rating', body: 'Global ranking system with regional leaderboards.' },
      { title: 'Gameplay', bullets: ['Sub-tick architecture', 'Reactive smokes', 'Refreshed maps & lighting'] }
    ],
    // Deine neue URL (Gaming-CDN Banner)
    heroUrl: 'https://gaming-cdn.com/img/products/9459/pcover/1400x500/9459.jpg?v=1742208833',
    // kein heroSrcset: dieses Motiv ist 1400×500 (~2.8:1); wir vermeiden falsche Breitenhinweise
    trailers: ['nSE38xjMLqE'],
    trailerYouTubeId: 'nSE38xjMLqE',
    publisher: 'Valve',
    developer: 'Valve',
    platforms: ['PC'],
    genres: ['FPS'],
    rating: { system: 'PEGI', value: '18' },
    competitive: true,
    featured: false,
    heroKey: 'hero-background.webp',
    storeLinks: {
      steam: 'https://store.steampowered.com/app/730/CounterStrike_2/',
      official: 'https://www.counter-strike.net/cs2'
    }
  },

  {
    key: 'mario-kart',
    name: 'Mario Kart World',
    releaseDate: '2025-06-05',
    icon: 'mario-kart.webp',
    shortDescription: 'Arcade racing fun in a connected world.',
    longDescription:
      'Mario Kart World is the newest entry in the series, exclusive to Nintendo Switch 2: connected hub tracks, local & online multiplayer, battle modes, vehicle customization, and new items. Easy to pick up, hard to master – now with up to 24 players online.',
    sections: [
      { title: 'Grand Prix & VS', body: 'Race cups, time trials and versus matches.' },
      { title: 'Gameplay', bullets: ['Connected “World” concept', 'Local & online multiplayer', 'Assist options for newcomers'] }
    ],
    heroUrl: 'https://www.nintendo.com/eu/media/images/assets/nintendo_switch_2_games/mariokartworld/2x1_NSwitch2_MarioKartWorld_image1600w.jpg',
    heroSrcset: [
      'https://www.nintendo.com/eu/media/images/assets/nintendo_switch_2_games/mariokartworld/2x1_NSwitch2_MarioKartWorld_image1600w.jpg 1280w',
      'https://www.nintendo.com/eu/media/images/assets/nintendo_switch_2_games/mariokartworld/2x1_NSwitch2_MarioKartWorld_image1600w.jpg 1920w',
      'https://www.nintendo.com/eu/media/images/assets/nintendo_switch_2_games/mariokartworld/2x1_NSwitch2_MarioKartWorld_image1600w.jpg 2560w'
    ].join(', '),
    trailers: ['kEVBSZk51R0'],
    trailerYouTubeId: 'kEVBSZk51R0',
    publisher: 'Nintendo',
    developer: 'Nintendo',
    platforms: ['Switch 2'],
    genres: ['Racing'],
    rating: { system: 'PEGI', value: '3' },
    competitive: false,
    featured: false,
    heroKey: 'hero-background.webp',
    storeLinks: {
      switch: 'https://www.nintendo.com/us/store/products/mario-kart-world-switch-2/',
      official: 'https://www.nintendo.com/us/gaming-systems/switch-2/featured-games/mario-kart-world/world/'
    }
  },

  {
    key: 'valorant',
    name: 'Valorant',
    releaseDate: '2020-06-02',
    icon: 'valorant.webp',
    shortDescription: 'Tactical 5v5 hero shooter by Riot Games.',
    longDescription:
      'VALORANT is a competitive 5v5 tactical shooter combining precise gunplay with unique agent abilities. It features ranked play, esports integration through VCT, regular Acts with new maps and agents, and now cross-progression across PC and consoles.',
    sections: [
      { title: 'Competitive & Premier', body: 'MMR-based ranks and in-game tournament system Premier.' },
      { title: 'Gameplay', bullets: ['Agent abilities + precise gunplay', 'Economy & utility mastery', 'Regular Acts & balance updates'] }
    ],
    heroUrl: 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/news/3dcf037fc3a5f30434519a00b8c37f1f593930d9-4096x1728.png?auto=format&fit=fill&q=80&w=1905',
    heroSrcset: [
      'https://cmsassets.rgpub.io/sanity/images/dsfx7636/news/3dcf037fc3a5f30434519a00b8c37f1f593930d9-4096x1728.png?auto=format&fit=fill&q=80&w=1280 1280w',
      'https://cmsassets.rgpub.io/sanity/images/dsfx7636/news/3dcf037fc3a5f30434519a00b8c37f1f593930d9-4096x1728.png?auto=format&fit=fill&q=80&w=1920 1920w',
      'https://cmsassets.rgpub.io/sanity/images/dsfx7636/news/3dcf037fc3a5f30434519a00b8c37f1f593930d9-4096x1728.png?auto=format&fit=fill&q=80&w=2560 2560w'
    ].join(', '),
    trailers: ['lXM4T6G8fK4'],
    trailerYouTubeId: 'lXM4T6G8fK4',
    publisher: 'Riot Games',
    developer: 'Riot Games',
    platforms: ['PC', 'PS5', 'Xbox Series X|S'],
    genres: ['FPS'],
    rating: { system: 'PEGI', value: '16' },
    competitive: true,
    featured: true,
    heroKey: 'hero-background.webp',
    storeLinks: {
      official: 'https://playvalorant.com/',
      psn: 'https://www.playstation.com/en-us/games/valorant/',
      xbox: 'https://www.xbox.com/en-US/games/valorant',
      epic: 'https://store.epicgames.com/en-US/p/valorant'
    }
  }
];
